import * as at from './actionTypes';
import * as auth from '../../services/auth/actionTypes';

const INITIAL_STATE = {
	email: '',
  password: ''
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case at.EMAIL_CHANGED:
      return { ...state, email: action.payload };
    case at.PASSWORD_CHANGED:
      return { ...state, password: action.payload };
    case auth.LOGIN:
      return { ...state, loading: true, error: '' };
    case auth.LOGIN_SUCCESS:
      return { ...state, ...INITIAL_STATE };
    case auth.LOGIN_FAIL:
      return {
        ...state,
        error: 'Authentication Failed.',
        password: '',
        loading: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Login/reducer.js